import api from 'service/api'

const dponetAPI = api.create('guestPortal')

const get = async ({ ...params }) => {
  return await dponetAPI.get('/regulation_versions', { params })
}

const accept = async (regulationVersionId) => {
  return await dponetAPI.post(
    `/regulation_versions/${regulationVersionId}/regulation_version_acceptances`,
  )
}

const regulationVersions = {
  get,
  accept,
}

export default regulationVersions
